export { ZReceiptInformation, ZAccount } from '../model/schema'
